'use strict';

var jsxRuntime = require('react/jsx-runtime');
var EnvContext = require('./EnvContext.cjs');

function EnvContextProvider({
  children,
  env
}) {
  return /* @__PURE__ */ jsxRuntime.jsx(EnvContext.EnvContext.Provider, { value: { env }, children });
}

exports.EnvContextProvider = EnvContextProvider;
//# sourceMappingURL=EnvContextProvider.cjs.map
